import { render } from "./CheckoutProduct.vue?vue&type=template&id=4b307945&scoped=true"
import script from "./CheckoutProduct.vue?vue&type=script&lang=js"
export * from "./CheckoutProduct.vue?vue&type=script&lang=js"

import "./CheckoutProduct.vue?vue&type=style&index=0&id=4b307945&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b307945"]])

export default __exports__